<template>
  <div class="file">
    <div class="file-content">
      <page-list-container class="file-content-bottom" :total="total" :pageSize="pageSize"
        :inputCurrentPage="currentPage" @onPageChange="onPageChange" @onSizeChange="onSizeChange">
        <el-table :data="fileArray" height="100%" @row-click="onRowClick" :row-class-name="getRowClassName"
          :row-style="{ height: '54px' }" :cell-style="{ height: '54px', padding: '0' }" style="width: 100%">
          <el-table-column prop="model" label="设备型号" width="200" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ placeholderText(row.model) }}
            </template>
          </el-table-column>

          <el-table-column prop="deviceSn" label="设备SN" width="150" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ placeholderText(row.deviceSn) }}
            </template>
          </el-table-column>

          <el-table-column prop="inboundTime" label="入库时间" width="140">
            <template slot-scope="{ row }">
              {{ formatStorageTime(row.inboundTime) }}
            </template>
          </el-table-column>

          <el-table-column prop="expiryDate" label="有效期" width="120">
            <template slot-scope="{ row }">
              {{ formatValidityPeriod(row.expiryDate) }}
            </template>
          </el-table-column>

          <el-table-column prop="trafficCardId" label="关联流量卡ID" width="150" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-if="row.expirationStatus === 3" :style="{ textDecoration: 'line-through' }">
                {{ row.trafficCardId }}
              </span>
              <span v-else :style="{ color: getTrafficCardColor(row.expirationStatus) }">
                {{ placeholderText(row.trafficCardId) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="deviceAttribute" label="设备属性" width="120">
            <template slot-scope="{ row }">
              {{ formatDeviceProperty(row.deviceAttribute) }}
            </template>
          </el-table-column>

          <el-table-column label="合同质保期" width="130">
            <template slot-scope="{ row }">
              {{ formatWarrantyPeriod(row.outboundTime, row.warrantyYears, row.deviceAttribute) }}
            </template>
          </el-table-column>

          <el-table-column prop="deviceStatus" label="设备状态" width="120">
            <template slot-scope="{ row }">
              {{ formatDeviceStatus(row.deviceStatus) }}
            </template>
          </el-table-column>

          <el-table-column prop="outboundPersonName" label="负责人" width="120">
            <template slot-scope="{ row }">
              {{ placeholderText(row.outboundPersonName) }}
            </template>
          </el-table-column>

          <el-table-column prop="outboundHospitalName" label="当前机构" width="150" show-overflow-tooltip>
            <template slot-scope="{ row }">
              {{ placeholderText(row.outboundHospitalName) }}
            </template>
          </el-table-column>

          <el-table-column prop="currentScenario" label="当前场景" width="120">
            <template slot-scope="{ row }">
              {{ formatCurrentScenario(row.currentScenario, row.nppvRemarks) }}
            </template>
          </el-table-column>

          <el-table-column width="400" fixed="right">
            <template slot="header">
              <div class="header-content">
                <div v-if="isSeniorAdministrator" class="header-buttons">
                  <button class="header-button" @click="onAddDeviceClick">
                    设备入库
                  </button>
                  <button class="header-button" @click="onBatchImportClick">
                    批量入库
                  </button>
                </div>
                <span v-else>操作</span>
              </div>
            </template>
            <template slot-scope="{ row }">
              <div class="operation-buttons">
                <el-button type="text" @click.stop="onDeviceArchiveClick(row)">
                  设备档案
                </el-button>
                <el-button v-if="row.deviceStatus === 1 && isSeniorAdministrator" type="text"
                  @click.stop="onDeviceOutboundClick(row)">
                  出库
                </el-button>
                <el-button v-if="row.deviceStatus === 3 && row.currentScenario !== 3" type="text" @click.stop="onDeviceRoamClick(row)">
                  流转
                </el-button>
                <el-button type="text" @click.stop="onReturnWarehouseClick(row)"
                  v-if="shouldShowReturnButton(row) && row.currentScenario !== 3">
                  回库
                </el-button>
                <el-button type="text" @click.stop="onEquipmentFailureClick(row)" v-if="row.currentScenario !== 3">
                  设备故障
                </el-button>
                <el-button v-if="row.trafficCardId && row.trafficCardId.trim()" type="text"
                  @click.stop="onTrafficCardClick(row)">
                  流量卡
                </el-button>
                <el-button type="text" @click.stop="onDeviceLogClick(row)">
                  日志
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </page-list-container>
    </div>
    <file-add v-if="isShowAddDevice" @onCloseClick="onAddDeviceCloseClick"
      @onConfirmClick="onAddDeviceConfirmClick"></file-add>
    <edit-device-archive :model="selectedModel" :viewMode="isViewMode" :isSeniorAdministrator="isSeniorAdministrator"
      v-if="isShowEditDevice" @onCloseClick="onEditDeviceCloseClick" @onConfirmClick="onEditFileConfirmClick"
      @onLostClick="onLostClick" @onLostComplete="onLostComplete"
      @onDiscardClick="onDiscardClick"></edit-device-archive>
    <device-outbound :deviceData="selectedModel" :hospitalList="hospitalList" v-if="isShowOutboundDevice"
      @onCloseClick="onOutboundDeviceCloseClick" @onConfirmClick="onOutboundDeviceConfirmClick"></device-outbound>
    <roam :deviceData="selectedModel" :hospitalList="hospitalList" v-if="isShowRoamDevice"
      @onCloseClick="onRoamDeviceCloseClick" @onConfirmClick="onRoamDeviceConfirmClick"></roam>
    <log :deviceData="selectedModel" v-if="isShowLogDevice" @onCloseClick="onLogDeviceCloseClick"></log>
    <return-warehouse :deviceData="selectedModel" :hospitalList="hospitalList" v-if="isShowReturnWarehouse"
      @onCloseClick="onReturnWarehouseCloseClick" @onConfirmClick="onReturnWarehouseConfirmClick"></return-warehouse>
    <equipment-failure :deviceData="selectedModel" :hospitalList="hospitalList" v-if="isShowEquipmentFailure"
      @onCloseClick="onEquipmentFailureCloseClick" @onSubmitFailure="onSubmitFailureRequest"
      @onSubmitMaintenance="onSubmitMaintenanceRequest" @onSubmitComplete="onSubmitCompleteRequest"></equipment-failure>
    <import-file-dialog v-if="isShowImportDialog" @onCloseClick="onImportDialogClose" @onImportSuccess="onImportSuccess"></import-file-dialog>
  </div>
</template>

<script>
import PageListContainer from "@c/operation-log/common/paging-list/page-list-container.vue";
import KeywordSearch from "@c/common/keyword-search.vue";
import FilterBar from "./filter-bar.vue";
import Pagination from "@c/common/pagination2.vue";
import FileAdd from "./file-add.vue";
import EditDeviceArchive from "./edit-device-archive.vue";
import DeviceOutbound from "./device-outbound.vue";
import Roam from "./roam.vue";
import Log from "./log.vue";
import ReturnWarehouse from "./return-warehouse.vue";
import EquipmentFailure from "./equipment-failure.vue";
import ImportFileDialog from "./import-file-dialog.vue";
import { DateTool } from "@js/date-tool.js";
import { downloadExportFile } from "@js/report-export-tool.js";

export default {
  components: {
    PageListContainer,
    KeywordSearch,
    FilterBar,
    Pagination,
    FileAdd,
    EditDeviceArchive,
    DeviceOutbound,
    Roam,
    Log,
    ReturnWarehouse,
    EquipmentFailure,
    ImportFileDialog,
  },

  props: {
    canDeleteDevice: Boolean,
  },

  data: function () {
    return {
      fileArray: [],
      total: undefined,
      pageSize: undefined,
      currentPage: 1,
      keywords: "",
      searchConditions: {
        model: undefined,
        deviceSn: undefined,
        deviceAttribute: undefined,
        deviceStatus: undefined,
        faultOrderStatus: undefined,
        outboundPersonId: undefined,
        outboundHospitalId: undefined,
        expirationStatus: undefined,
        deviceNature: undefined,
        keyword: undefined,
        deviceAttribute: undefined,
      },
      selectedModel: undefined,
      isShowAddDevice: false,
      isShowEditDevice: false,
      isViewMode: false,
      isShowOutboundDevice: false,
      isShowRoamDevice: false,
      isShowLogDevice: false,
      isShowReturnWarehouse: false,
      isShowEquipmentFailure: false,
      isShowImportDialog: false,
      hospitalList: [],
    };
  },

  computed: {
    selectedID() {
      return this.selectedModel == undefined
        ? undefined
        : this.selectedModel.id;
    },

    isSeniorAdministrator() {
      return this.$store.getters.isSeniorAdministrator;
    },
  },

  async mounted() {
    this.pageSize = this.bestPageSizeComputer();
    await this.getHospitalList();
    this.fileListRequest();
  },

  methods: {
    bestPageSizeComputer() {
      return 10;
    },

    onSearchClick(value) {
      this.currentPage = 1;
      this.keywords = value;
      this.fileListRequest();
    },

    onSearch(conditions) {
      this.currentPage = 1;
      this.searchConditions = conditions;
      this.keywords = conditions.keyword || "";
      this.fileListRequest();
    },

    onAddDeviceClick() {
      this.isShowAddDevice = true;
    },

    onBatchImportClick() {
      this.isShowImportDialog = true;
    },

    // 处理导出
    async onExport(conditions) {
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          model: this.searchConditions.model,
          deviceSn: this.searchConditions.deviceSn,
          deviceAttribute: this.searchConditions.deviceAttribute,
          deviceStatus: this.searchConditions.deviceStatus,
          faultOrderStatus: this.searchConditions.faultOrderStatus,
          outboundPersonId: this.searchConditions.outboundPersonId,
          outboundHospitalId: this.searchConditions.outboundHospitalId,
          expirationStatus: this.searchConditions.expirationStatus,
          deviceNature: this.searchConditions.deviceNature,
        };
        const response = await this.$api.sleepDeviceArchivesExport(params);
        downloadExportFile(response);
        this.$toast.showGreen("导出成功");
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.fileListRequest();
    },

    onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fileListRequest();
    },

    onCellSelectClick(model) {
      this.selectedModel = model;
    },

    onStopClick() {
      this.$alert.show("设备操作", "是否要终止监测？", () => {
        this.deviceStopRequest();
      });
    },

    onAddUserClick() {
      this.$emit("onAddUserClick", this.selectedModel);
    },

    onDeleteClick() {
      this.$alert.show("设备操作", "是否要删除设备？", () => {
        this.deviceDeleteRequest();
      });
    },

    onEditClick() {
      this.isViewMode = false;
      this.isShowEditDevice = true;
    },

    onDeviceArchiveClick(row) {
      this.selectedModel = row;
      this.isViewMode = true;
      this.isShowEditDevice = true;
    },

    onDeviceOutboundClick(row) {
      this.selectedModel = row;
      this.isShowOutboundDevice = true;
    },

    onDeviceRoamClick(row) {
      this.selectedModel = row;
      this.isShowRoamDevice = true;
    },

    onDeviceLogClick(row) {
      this.selectedModel = row;
      this.isShowLogDevice = true;
    },

    onRowClick(row) {
      this.selectedModel = row;
    },

    getRowClassName({ row }) {
      return this.selectedModel && this.selectedModel.id === row.id ? 'selected-row' : '';
    },

    // 判断是否显示回库按钮
    shouldShowReturnButton(row) {
      if (!this.isSeniorAdministrator) return false;
      
      // 只有已售(2)或流转中(3)状态显示回库按钮
      // 故障维修(4)状态不显示回库按钮
      return row.deviceStatus === 2 || row.deviceStatus === 3;
    },

    placeholderText(rawValue, unitText = "") {
      if (!rawValue || rawValue === "null") {
        return "-";
      } else {
        const finalUnitText = unitText ? ` ${unitText}` : "";
        return `${rawValue}${finalUnitText}`;
      }
    },

    formatStorageTime(inboundTime) {
      return this.placeholderText(
        DateTool.formatDate(
          DateTool.strToDate(inboundTime),
          "Y-M-D h:m"
        )
      );
    },

    formatValidityPeriod(expiryDate) {
      return this.placeholderText(
        expiryDate ?
          DateTool.formatDate(
            DateTool.strToDate(expiryDate),
            "Y-M-D"
          ) : ""
      );
    },

    formatDeviceProperty(deviceAttribute) {
      switch (deviceAttribute) {
        case 1:
          return "正式进院";
        case 2:
          return "试用";
        default:
          return this.placeholderText("");
      }
    },

    formatDeviceStatus(deviceStatus) {
      switch (deviceStatus) {
        case 1:
          return "在库";
        case 2:
          return "已售";
        case 3:
          return "流转中";
        case 4:
          return "故障维修";
        case 5:
          return "废弃";
        case 6:
          return "丢失";
        default:
          return this.placeholderText("");
      }
    },

    formatWarrantyPeriod(outboundTime, warrantyYears, deviceAttribute) {
      // 如果设备属性为试用（2），显示"-"
      if (deviceAttribute === 2) {
        return "-";
      }

      // 如枟设备属性为正式进院（1）
      if (deviceAttribute === 1) {
        // 如果没有质保年数，显示"待补充"
        if (!warrantyYears) {
          return "待补充";
        }

        // 如果没有出库时间但有质保年数，也显示"待补充"
        if (!outboundTime) {
          return "待补充";
        }

        // 如果都有，计算合同质保期
        try {
          const outboundDate = DateTool.strToDate(outboundTime);
          const warrantyEndDate = new Date(outboundDate);
          warrantyEndDate.setFullYear(warrantyEndDate.getFullYear() + warrantyYears);

          return DateTool.formatDate(warrantyEndDate, "Y-M-D");
        } catch (error) {
          return "待补充";
        }
      }

      // 其他情况显示"-"
      return this.placeholderText("");
    },

    formatCurrentScenario(currentScenario, nppvRemarks) {
      switch (currentScenario) {
        case 0:
          return "-";
        case 1:
          return "睡眠监测";
        case 2:
          return "初筛";
        case 3:
          return nppvRemarks ? `nppv(${nppvRemarks})` : "nppv";
        default:
          return "-";
      }
    },

    getTrafficCardColor(expirationStatus) {
      switch (expirationStatus) {
        case 1:
          return "#FF9A00"
        case 2:
        case 4:
        case 5:
          return "#ff0000";
        default:
          return "#666666";
      }
    },

    onAddDeviceCloseClick() {
      this.isShowAddDevice = false;
    },

    onAddDeviceConfirmClick(info) {
      this.isShowAddDevice = false;
      this.fileAddRequest(info);
    },

    onEditDeviceCloseClick() {
      this.isShowEditDevice = false;
      this.isViewMode = false;
    },

    onEditFileConfirmClick(info) {
      this.isShowEditDevice = false;
      this.isViewMode = false;
      this.fileEditRequest(info);
    },

    onLostClick(model) {
      this.$alert.show("设备操作", "是否要标记设备为丢失？", () => {
        this.deviceLostRequest(model);
      });
    },

    onLostComplete(model) {
      // 丢失操作完成后，直接刷新列表，不弹出确认框
      this.fileListRequest();
    },

    onDiscardClick(model) {
      this.$alert.show("设备操作", "是否要标记设备为废弃？", () => {
        this.deviceDiscardRequest(model);
      });
    },

    onOutboundDeviceCloseClick() {
      this.isShowOutboundDevice = false;
    },

    onOutboundDeviceConfirmClick(info) {
      this.isShowOutboundDevice = false;
      this.deviceOutboundRequest(info);
    },

    onRoamDeviceCloseClick() {
      this.isShowRoamDevice = false;
    },

    onRoamDeviceConfirmClick(info) {
      this.isShowRoamDevice = false;
      this.deviceRoamRequest(info);
    },

    onLogDeviceCloseClick() {
      this.isShowLogDevice = false;
    },

    onReturnWarehouseClick(row) {
      this.selectedModel = row;
      this.isShowReturnWarehouse = true;
    },

    onReturnWarehouseCloseClick() {
      this.isShowReturnWarehouse = false;
    },

    onReturnWarehouseConfirmClick(info) {
      this.isShowReturnWarehouse = false;
      this.fileListRequest(); // 刷新列表
    },

    onEquipmentFailureClick(row) {
      this.selectedModel = row;
      this.isShowEquipmentFailure = true;
    },

    onEquipmentFailureCloseClick() {
      this.isShowEquipmentFailure = false;
    },

    onTrafficCardClick(row) {
      this.selectedModel = row;
      this.getTrafficCardInfo(row.trafficCardId);
    },

    onSubmitFailureRequest(data) {
      this.equipmentFailureSubmitRequest(data);
    },

    onSubmitMaintenanceRequest(data) {
      this.equipmentFailureMaintenanceRequest(data);
    },

    onSubmitCompleteRequest(data) {
      this.equipmentFailureCompleteRequest(data);
    },

    onImportDialogClose() {
      this.isShowImportDialog = false;
    },

    onImportSuccess() {
      this.isShowImportDialog = false;
      this.fileListRequest(); // 导入成功后刷新设备列表
    },

    async fileListRequest() {
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          model: this.searchConditions.model,
          deviceSn: this.searchConditions.deviceSn,
          deviceAttribute: this.searchConditions.deviceAttribute,
          deviceStatus: this.searchConditions.deviceStatus,
          faultOrderStatus: this.searchConditions.faultOrderStatus,
          outboundPersonId: this.searchConditions.outboundPersonId,
          outboundHospitalId: this.searchConditions.outboundHospitalId,
          expirationStatus: this.searchConditions.expirationStatus,
          deviceNature: this.searchConditions.deviceNature,
        };
        const response = await this.$api.getEquipmentFileList(params);
        this.total = response.total;
        this.fileArray = response.list;
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceDeleteRequest() {
      try {
        const params = {
          id: this.selectedModel.id,
        };
        await this.$api.deleteDevice(params);
        this.$toast.showGreen(MSG.deviceDeleteSucceed);
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceStopRequest() {
      try {
        const params = {
          id: this.selectedModel.id,
        };
        await this.$api.stopDevice(params);
        this.fileListRequest();
        this.$toast.showGreenLink("操作成功，", "点此马上去回收设备！", () => {
          this.$emit("onRecycleDeviceClick", this.selectedModel);
        });
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async fileAddRequest(info) {
      try {
        const params = {
          model: info.model,
          deviceTypeId: info.deviceTypeId,
          deviceSn: info.deviceSn,
          ringType: info.ringType,
          productionDate: info.productionDate,
          expiryDate: info.expiryDate,
          batchNumber: info.batchNumber,
          trafficCardId: info.trafficCardId,
          deviceNature: info.deviceNature,
          deviceStatus: info.deviceStatus,
          inboundRemarks: info.inboundRemarks,
        };

        if (info.model === 'ZG-M11B') {
          params.deviceSeries = info.deviceSeries;
        }

        await this.$api.getEquipmentFileAdd(params);
        this.$toast.showGreen(MSG.deviceAddSucceed);
        this.currentPage = 1;
        this.keywords = "";
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async fileEditRequest(info) {
      try {
        let params = {};

        if (info.hasOwnProperty('outboundTime') || info.hasOwnProperty('warrantyYears')) {
          params = {
            id: info.id,
            deviceAttribute: info.deviceAttribute,
            deviceStatus: info.deviceStatus,
            outboundPersonId: info.outboundPersonId,
            outboundHospitalId: info.outboundHospitalId,
            outboundTime: info.outboundTime,
            warrantyYears: info.warrantyYears,
            contractNumber: info.contractNumber,
            contractSignatory: info.contractSignatory,
            outboundRemarks: info.outboundRemarks,
            outboundRingIds:info.outboundRingIds,
          };
        } else {
          params = {
            id: info.id,
            model: info.model,
            deviceTypeId: info.deviceTypeId,
            deviceSn: info.deviceSn,
            ringType: info.ringType,
            productionDate: info.productionDate,
            expiryDate: info.expiryDate,
            batchNumber: info.batchNumber,
            trafficCardId: info.trafficCardId,
            deviceNature: info.deviceNature,
            deviceStatus: info.deviceStatus,
            inboundRemarks: info.inboundRemarks,
            deviceSeries:info.deviceSeries,
          };
        }
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen(MSG.deviceEditSucceed);
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceLostRequest(model) {
      console.log('设备丢失功能待实现');
    },

    async deviceDiscardRequest(model) {
      console.log('设备废弃功能待实现');
    },

    async deviceOutboundRequest(info) {
      try {
        const params = {
          id: this.selectedModel.id,
          deviceAttribute: info.deviceAttribute,
          deviceStatus: info.deviceStatus,
          outboundRingIds: info.outboundRingIds,
          outboundPersonId: info.outboundPersonId,
          outboundHospitalId: info.outboundHospitalId,
          outboundTime: info.outboundTime,
          warrantyYears: info.warrantyYears,
          contractNumber: info.contractNumber,
          contractSignatory: info.contractSignatory,
          outboundRemarks: info.outboundRemarks,
        };
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen("设备出库成功");
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async deviceRoamRequest(info) {
      try {
        const params = {
          id: this.selectedModel.id,
          deviceAttribute: info.deviceAttribute,
          deviceStatus: info.deviceStatus,
          outboundRingIds: info.outboundRingIds,
          outboundPersonId: info.outboundPersonId,
          outboundHospitalId: info.outboundHospitalId,
        };
        await this.$api.getEquipmentFileUpdate(params);
        this.$toast.showGreen("设备流转成功");
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async getHospitalList() {
      try {
        const params = {
          parentId: this.$store.state.accountInfo.id
        };
        const response = await this.$api.getHospitalList(params);

        this.hospitalList = response.map((item) => {
          return {
            value: item.id,
            label: item.hospitalName
          };
        });
      } catch (error) {
        console.error('获取机构列表失败:', error);
      }
    },

    async deviceReturnWarehouseRequest(info) {
      try {
        const params = {
          deviceId: this.selectedModel.id,
          deviceAttribute: info.deviceAttribute,
          deviceStatus: info.deviceStatus,
          outboundRingIds: info.outboundRingIds,
          remarks: info.remarks,
        };
        await this.$api.getDeviceOutboundList(params);
        this.$toast.showGreen("设备回库成功");
        this.fileListRequest();
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async equipmentFailureSubmitRequest(data) {
      try {
        // 调用提交故障接口
        const params = {
          deviceId: this.selectedModel.id,
          associatedInstitutionId: data.associatedInstitutionId,
          processingDetails: data.processingDetails,
          deviceSn: data.deviceSn,
          faultOrderStatus: 1,
          faultImages: data.faultImages || '' // 添加故障图片/视频URL字段，默认空字符串
        };
        await this.$api.getSleepDeviceMaintenanceOrderSave(params);
        this.$toast.showGreen("故障提交成功");
        this.isShowEquipmentFailure = false;
        this.fileListRequest(); // 刷新设备列表
      } catch (error) {
        console.error('故障提交失败:', error);
        this.$toast.showRed(error);
      }
    },

    async equipmentFailureMaintenanceRequest(data) {
      try {
        // 调用故障运维处理接口
        await this.$api.getSleepDeviceMaintenanceOrderUpdate(data);
        this.$toast.showGreen("故障运维处理更新成功");
        this.isShowEquipmentFailure = false;
        this.fileListRequest(); // 刷新设备列表
      } catch (error) {
        console.error('故障处理失败:', error);
        this.$toast.showRed("故障处理失败");
      }
    },

    async equipmentFailureCompleteRequest(data) {
      try {
        // 调用故障完毕接口
        const params = {
          id: data.id,
          faultCompletedStatus: data.faultCompletedStatus,
          outboundPersonId: data.outboundPersonId,
          outboundHospitalId: data.outboundHospitalId,
          returnTrackingNumber: data.returnTrackingNumber,
          receiver: data.receiver,
          receiveAddress: data.receiveAddress,
          scrapReason: data.scrapReason,
        };

        await this.$api.getSleepDeviceMaintenanceOrderFaultCompleted(params);
        this.$toast.showGreen("故障完毕提交成功");
        this.isShowEquipmentFailure = false;
        this.fileListRequest(); // 刷新列表
      } catch (error) {

        this.$toast.showRed(error);
      }
    },

    async getTrafficCardInfo(cardNumber) {
      try {
        const params = {
          cardNumber: cardNumber
        };

        console.log('params', params);
        const response = await this.$api.getCardInfo(params);
        this.showTrafficCardInfo(response);
      } catch (error) {
        this.$toast.showRed("获取流量卡信息失败：" + error);
      }
    },

    showTrafficCardInfo(cardInfo) {
      const statusText = this.formatCardStatus(cardInfo.status);
      const startTimeText = this.formatCardTime(cardInfo.startTime);
      const endTimeText = this.formatCardTime(cardInfo.endTime);

      const content = `
        <div style="text-align: left; font-size: 14px; line-height: 24px;">
          <p><strong>卡状态：</strong>${statusText}</p>
          <p><strong>剩余流量：</strong>${cardInfo.flow || '-'}</p>
          <p><strong>服务期开始时间：</strong>${startTimeText}</p>
          <p><strong>服务期结束时间：</strong>${endTimeText}</p>
          <p><strong>区域限制：</strong>${cardInfo.area || '-'}</p>
          <p><strong>厂家：</strong>${cardInfo.factory || '-'}</p>
        </div>
      `;

      this.$msgbox({
        title: '流量卡信息',
        dangerouslyUseHTMLString: true,
        message: content,
        showCancelButton: false,
        confirmButtonText: '确定',
        type: 'info'
      });
    },

    formatCardStatus(status) {
      switch (status) {
        case 1:
          return "正常";
        case 2:
          return "停用";
        case 3:
          return "欠费";
        default:
          return status || "-";
      }
    },

    formatCardTime(timeStr) {
      if (!timeStr) return "-";
      try {
        return DateTool.formatDate(
          DateTool.strToDate(timeStr),
          "Y-M-D"
        );
      } catch (error) {
        return timeStr;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  &-content {
    background-color: white;
    border-radius: rem(2);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-top {
      font-size: rem(16);
      width: 100%;
      height: rem(59);
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      &-left {
        display: flex;

        &-title {
          color: #325fac;
          font-size: rem(14);
          border-bottom: rem(2) solid #325fac;
          width: rem(100);
          height: rem(32);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &-add-device {
          color: white;
          background-color: #325fac;
          font-size: rem(14);
          width: rem(88);
          height: rem(32);
          border-radius: 4px;
          margin-left: rem(74);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    &-bottom {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      &-list {
        width: 100%;
      }

      &-empty-info {
        color: rgba($color: black, $alpha: 0.85);
        font-size: rem(14);
        width: 100%;
        margin-top: rem(100);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-pagination {
        width: 100%;
        height: rem(90);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: rem(8);
  justify-content: flex-start;

  .el-button--text {
    color: #325FAC !important;
    background-color: transparent !important;
    border: none !important;
    padding: rem(4) rem(8) !important;

    &:hover,
    &:focus {
      color: #325FAC !important;
      background-color: #f5f5f5 !important;
    }

    &:active {
      color: #325FAC !important;
      background-color: #e6f7ff !important;
    }
  }
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.header-buttons {
  display: flex;
  gap: rem(8);
  align-items: center;
}

.header-button {
  color: white;
  background-color: #325fac;
  font-size: rem(14);
  border-radius: rem(4);
  width: rem(88);
  height: rem(28);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgb(91, 127, 189);
  }

  &:active {
    background-color: rgb(45, 86, 155);
  }
}

:deep(.el-table) {
  font-size: rem(14);

  .el-table__header-wrapper th,
  .el-table__fixed .el-table__header-wrapper th,
  .el-table__fixed-right .el-table__header-wrapper th {
    background-color: #fafafa !important;
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: rem(14) !important;
    font-weight: normal !important;
    border-bottom: rem(1) solid #e8e8e8 !important;
    height: 54px !important;
    padding: 0 !important;
    text-align: center !important;
  }

  .el-table__fixed-right-patch {
    background-color: #fafafa !important;
    height: 54px !important;
  }

  .el-table__fixed-right .el-table__header th {
    background-color: #fafafa !important;
    height: 54px !important;
  }

  .el-table__fixed-right .el-table__header {
    height: 54px !important;
  }

  .el-table__body-wrapper td,
  .el-table__fixed .el-table__body-wrapper td,
  .el-table__fixed-right .el-table__body-wrapper td {
    color: #666666 !important;
    font-size: rem(14) !important;
    border-bottom: rem(1) solid #e8e8e8 !important;
    height: 54px !important;
    padding: 0 !important;
    text-align: center !important;
    line-height: rem(22) !important;
  }

  .el-table__body tr:hover td,
  .el-table__fixed .el-table__body tr:hover td,
  .el-table__fixed-right .el-table__body tr:hover td {
    background-color: #f7f7f7 !important;
  }

  .selected-row td,
  .el-table__fixed .selected-row td,
  .el-table__fixed-right .selected-row td {
    background-color: #e6f7ff !important;
    height: 54px !important;
  }

  .selected-row:hover td,
  .el-table__fixed .selected-row:hover td,
  .el-table__fixed-right .selected-row:hover td {
    background-color: #e6f7ff !important;
    height: 54px !important;
  }

  &.el-table--border {
    border: rem(1) solid #e8e8e8;

    &::after {
      display: none;
    }

    &::before {
      display: none;
    }
  }

  .el-table__fixed {
    border-right: rem(1) solid #e8e8e8;
  }

  .el-table__fixed-right {
    border-left: rem(1) solid #e8e8e8;
  }
}
</style>